import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'

import * as types from './action-types'
import { fetchAgencyVenues } from './api'

export default function* saga() {
  yield takeLatestApiCall(types.AGENCY_VENUES_FETCH_BEGIN, fetchAgencyVenues)
}
